export enum BlokEndpoints {
  FetchBlokOwner = '/users/blok-owner',
  FetchBlokByAuthUser = '/blok-users',
  FetchBlokById = '/bloks/:id',
  FetchBlokForEvent = '/bloks/:id/event',
  FetchBlokBySlug = '/bloks/slug/:slug',
  FetchBlokForServicePage = '/bloks/:id/services',
  FetchBlokForPerkPage = '/bloks/:id/perks/blokInfo',
  FetchBloks = '/bloks',
  FetchJoinedBloks = '/bloks/joined',
  FetchJoinedBloksByAccountType = '/bloks/joined/:accountType/:state',
	FetchFeaturedBloks = '/bloks/featured',
	FetchAllBlokNames = '/bloks/all-bloks',
  FetchJoinedBloksByUserId = 'bloks/:talentId/joined',
  FetchJoinedBloksByUserIdByAccountType = 'bloks/:companyId/joined/company',
	IsUserMakeAiPhotos = 'bloks/joined/advanced',
	FetchJoinedAndPendingBloksByUserId = 'bloks/:talentId/approved-pending',
	FetchAllBloks = '/bloks/all',
  FetchBloksForAdmin = '/bloks/for/admin',
  FetchBlokPackages = '/packages/by/:ownerType/:ownerId',
  FetchBlokAnalytics = '/bloks/:id/statistics',
  FetchBlokTalents = '/bloks/:id/talents',
  FetchBlokTalentsForNonMembers = '/bloks/:id/featured-members',
  SubscribeTalent = '/bloks/:id/talents/create/:userId',
  FetchBlokCompanies = '/bloks/:id/companies',
  FetchBlokCompaniesForBlokOwner = '/bloks/:id/companies/withQuery',
  SubscribeCompany = '/bloks/:id/companies/create/:userId',
  FetchBlokJobPosts = '/bloks/:id/job-posts',
  FetchBloksByCompany = '/bloks/by/company/:id',
  FetchBloksByJobPost = '/bloks/by/jobPost/:id',
  UpdateBlokJobPostState = '/bloks/:id/job-posts/:jobPostId',
  UpdateBlokTalentState = '/bloks/:id/talents/:talentId',
	UpdateBlokTalentsState = '/bloks/:id/talents/:state/update-states',
  UpdateBlokCompanyState = '/bloks/:id/companies/:companyId',
  UpdateBlokCompaniesState = '/bloks/:id/companies/:state/update-states',
  CreateBlok = '/bloks',
  UpdateBlok = '/bloks/:id',
  CheckTalentIsExist = '/bloks/check-talents',
  UploadCoverPhoto = '/bloks/:id/updateCover',
  UploadAvatarPhoto = '/bloks/:id/updateAvatar',
	SetBlokCompleted = '/bloks/:id/setBlokCompleted',
  Purchase = '/payments/start',
  SendInvite = '/bloks/invites',
  FetchBlokInfo = '/bloks/:slug/info',
  FetchBlokSlug = '/bloks/:id/slug',
  FetchBlokAllPosts = '/bloks/posts/:ownerId',
  FetchBlokState = '/bloks/state',
  FetchBlokPost = '/bloks/posts/:ownerId/:id',
	FetchAllBlokPosts = '/bloks/post/all',
  BlokTalentCount = '/bloks/:id/talent-count',
  BlokCompanyCount = '/bloks/:id/company-count',
	FetchBlokPaywall = '/packages/by/:ownerType/:ownerId/paywall',
	UpdateBlokVisibility = '/bloks/:id/setVisibility',
  UpdateBlokApproval = '/bloks/:id/setRequireApproval',
  UpdateBlokPaymentRequirement = '/bloks/:id/setPaymentRequirement',
	FetchBlokDetailByAuthUser = '/blok-users/detail',
	PaywallPaymentStatus = '/payments/:blokId/member/payment-status',
	ConnectInstagramAccount = '/connected-accounts',
	DisconnectInstagramAccount = '/connected-accounts/disconnect',
}
